import React from "react";
import * as PropTypes from "prop-types";
import {animated} from "react-spring";
import ReactMarkdown from "react-markdown";

class Days extends React.Component {
    render() {
        return <animated.ul style={this.props.style} className="nav nav-tabs" role="tablist" data-aos="fade-up"
                            data-aos-delay="100">
            <li className="nav-item">
                <a className="nav-link active" href="#day-1" role="tab" data-toggle="tab">Day 1</a>
            </li>
            <li className="nav-item">
                <a className="nav-link" href="#day-2" role="tab" data-toggle="tab">Day 2</a>
            </li>
            <li className="nav-item">
                <a className="nav-link" href="#day-3" role="tab" data-toggle="tab">Day 3</a>
            </li>
        </animated.ul>;
    }
}

Days.propTypes = {style: PropTypes.any};

class SpeakerSlot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    render() {
        return <div className="row schedule-item" style={{cursor: "pointer"}}>
            <div className="col-md-2">
                <time>{this.props.time}</time>
            </div>
            <div className="col-md-2">
                {this.props.imageSrc && <>
                    <div className="speaker">
                        <img src={this.props.imageSrc} alt={this.props.imageAlt}/>
                    </div>
                </>}
            </div>
            <div className="col-md-8 text-left">
                <h4 onClick={()=>{
                    if(this.props.href){
                        window.location = this.props.href
                    }else{
                        this.setState({open: !this.state.open})
                    }
                }}>{this.props.talkTitle} <span style={this.props.color && {color: this.props.color}}>{this.props.speakerName}</span></h4>
                <p className={"text-left"}><ReactMarkdown>{this.props.summary}</ReactMarkdown></p>
                {this.state.open &&
                    <ReactMarkdown style={{fontSize: "15px", whiteSpace: "pre-line"}} className={"text-left"}>
                        {this.props.longDesc}
                    </ReactMarkdown>
                }
            </div>
        </div>;
    }
}

SpeakerSlot.propTypes = {
    time: PropTypes.any,
    imageSrc: PropTypes.string,
    imageAlt: PropTypes.string,
    talkTitle: PropTypes.string,
    summary: PropTypes.string,
    speakerName: PropTypes.string
};

class SpeakerSchedule extends React.Component {
    render() {
        return <animated.div style={this.props.style} className="tab-content row justify-content-center" data-aos="fade-up" data-aos-delay="200">
            <div role="tabpanel" className="col-lg-9 active" id="day-1">
                {this.props.schedule && this.props.schedule.map(slot =>
                    <SpeakerSlot
                        time={slot.time}
                        imageSrc={slot.imageSrc}
                        summary={slot.summary}
                        talkTitle={slot.talkTitle}
                        imageAlt={slot.imageAlt}
                        speakerName={slot.speakerName}
                        href={slot.href}
                        longDesc={slot.longDesc}
                        color={this.props.color}
                    />
                )}
            </div>
        </animated.div>;
    }
}

SpeakerSchedule.propTypes = {style: PropTypes.any, schedule: PropTypes.array};

export class Schedule extends React.Component {
    render() {
        return <section id="schedule" className="section-with-bg">
            <animated.div style={this.props.style} className="container">
                <div className="section-header">
                    <h2 style={this.props.color && {color: this.props.color}}> {this.props.title}</h2>
                {!this.props.tbd &&
                    <SpeakerSchedule color={this.props.color} style={this.props.style} schedule={this.props.schedule}/>
                }
                </div>
            </animated.div>

        </section>;
    }
}

Schedule.propTypes = {
    style: PropTypes.any,
    subHeading: PropTypes.string
};
